<template>
    <v-container class="no-padding-mobile no-padding-top">
        <v-layout>
            <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3 class="no-padding-top">
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-app-bar-nav-icon>
                            <v-progress-circular
                                :size="28"
                                :width="3"
                                indeterminate
                                color="white"
                                v-if="$apollo.queries.me.loading"
                            ></v-progress-circular>
                            <v-icon v-else>person</v-icon>
                        </v-app-bar-nav-icon>

                        <v-toolbar-title v-t="'title.my_account'"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn type="button" color="red" rounded @click="logout">
                            <v-icon left>logout</v-icon>
                            {{ $t("menu.logout") }}
                        </v-btn>
                    </v-toolbar>

                    <v-form lazy-validation @submit.prevent="update" ref="form">
                        <v-card-text class="text--primary">
                            <v-alert
                                class="mb-3"
                                :value="true"
                                type="error"
                                v-for="error in errors"
                                :key="error"
                                >{{ $t(`error.${error}`) }}</v-alert
                            >
                            <v-layout align-center justify-space-between>
                                <v-flex>
                                    <v-text-field
                                        v-model="me.email"
                                        :label="$t('label.email')"
                                        prepend-icon="mail"
                                        disabled
                                        type="email"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex class>
                                    <v-layout>
                                        <v-spacer />
                                        <v-btn
                                            color="primary"
                                            text
                                            type="button"
                                            @click="changeMailDialog = true"
                                            v-t="'button.change_email'"
                                        ></v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <AddressForm v-model="me.address" />

                            <v-select
                                :items="locales"
                                v-model="me.locale"
                                filled
                                prepend-icon="language"
                                :label="$t('label.language')"
                            ></v-select>
                            <v-text-field
                                filled
                                v-model="me.password"
                                prepend-icon="lock"
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                :type="showPassword ? 'text' : 'password'"
                                :rules="[rules.min]"
                                :label="$t('label.password')"
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                            <h3 v-t="'title.notification_settings'" class="display-1 mb-3"></h3>
                            <v-layout align-center wrap>
                                <v-icon class="mr-3">access_time</v-icon>
                                <v-checkbox
                                    class="mr-3"
                                    v-model="hasSchedule"
                                    value="1"
                                    :label="$t('label.active_schedule')"
                                    data-vv-name="checkbox"
                                    type="checkbox"
                                ></v-checkbox>
                                <v-flex>
                                    <v-layout align-center>
                                        <div class="mr-2 mt-2 subheading">
                                            {{ $t("label.once_a_day_at") }}
                                        </div>
                                        <v-select
                                            :items="hours"
                                            v-model="schedule"
                                            filled
                                            :disabled="!hasSchedule"
                                            :label="$t('label.scheduled_time')"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <h3 v-t="'title.notification_settings_email'" class="headline"></h3>
                            <v-layout
                                pt-2
                                row
                                wrap
                                v-for="(email, key) in me.notification.mail.emails"
                                :key="key"
                            >
                                <v-flex>
                                    <v-text-field
                                        v-model="me.notification.mail.emails[key]"
                                        :rules="[rules.required, rules.email]"
                                        type="email"
                                        required
                                        :label="$t('label.email')"
                                        filled
                                    >
                                        <v-btn
                                            slot="append-outer"
                                            style="top: -14px;"
                                            icon
                                            large
                                            color="red"
                                            text
                                            @click="removeEmails(key)"
                                        >
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-spacer></v-spacer>
                                <v-btn
                                    @click="addNotificationEmail"
                                    color="green"
                                    dark
                                    text
                                    rounded
                                >
                                    {{ $t("button.add_email") }}
                                    <v-icon right>add_circle</v-icon>
                                </v-btn>
                            </v-layout>

                            <!--PushNotifSettings
                                v-if="!$apollo.queries.me.loading && loaded"
                                :devices.sync="me.notification.push.devices"
                            /-->
                        </v-card-text>

                        <v-card-actions>
                            <v-btn
                                type="submit"
                                color="primary"
                                v-t="'button.save'"
                                block
                                :disabled="loading"
                                :loading="loading"
                            ></v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="changeMailDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <h3 v-t="'title.change_email'" class="headline mb-0"></h3>
                </v-card-title>
                <v-form
                    lazy-validation
                    @submit.prevent="changeEmail"
                    ref="emailForm"
                    v-if="!emailSuccess"
                >
                    <v-card-text class="text--primary">
                        <v-alert
                            :value="true"
                            type="error"
                            v-for="error in errorsMail"
                            :key="error"
                            >{{
                                $t(`error.${error.key || error}`, {
                                    wait_period: error.wait_period || 0,
                                })
                            }}</v-alert
                        >
                        <br />
                        <v-text-field
                            v-model="email"
                            type="email"
                            :rules="[rules.required, rules.email]"
                            prepend-icon="mail"
                            required
                            :label="$t('label.new_email')"
                            filled
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text v-t="'button.cancel'" @click="changeMailDialog = false"></v-btn>
                        <v-btn
                            color="primary"
                            type="submit"
                            :disabled="loading"
                            :loading="loading"
                            v-t="'button.submit'"
                        ></v-btn>
                    </v-card-actions>
                </v-form>
                <template v-else>
                    <v-card-text class="text--primary">
                        <p
                            class="title text-xs-center"
                            v-t="'message.email_waiting_for_validation'"
                        ></p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text v-t="'button.ok'" @click="changeMailDialog = false"></v-btn>
                    </v-card-actions>
                </template>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import { mapGetters, mapActions, mapMutations } from "vuex"
import isEmail from "validator/lib/isEmail"
import AddressForm from "@/components/AddressForm"
//import PushNotifSettings from "@/components/PushNotifSettings"
import Vue from "vue"
export default {
    mixins: [loadingMixin],
    components: { AddressForm },
    apollo: {
        me: {
            query: require("@/graphql/account/me.gql"),
            update({ me }) {
                if (!me.notification.push) {
                    me.notification.push = { devices: [] }
                }

                this.setInfo(me)
                setTimeout(() => {
                    this.loaded = true
                }, 100)
                return me
            },
        },
    },
    computed: {
        ...mapGetters({ getDarkMode: "user/darkMode" }),
        darkMode: {
            set(value) {
                this.setDarkMode(value)
            },
            get() {
                return this.getDarkMode
            },
        },
        schedule: {
            set(value) {
                if (value !== null) {
                    const d = new Date()
                    d.setHours(value + d.getTimezoneOffset() / 60)
                    this.me.notification.schedule.hour = d.getHours()
                } else {
                    this.me.notification.schedule.hour = null
                }
            },
            get() {
                if (this.me.notification.schedule.hour === null) {
                    return null
                }
                const d = new Date()
                d.setUTCHours(this.me.notification.schedule.hour)
                return d.getHours()
            },
        },
        hasSchedule: {
            set(value) {
                if (value) {
                    this.schedule = 12
                } else {
                    this.schedule = null
                }
            },
            get() {
                if (this.me.notification.schedule.hour === 0) {
                    return "1"
                }
                if (this.me.notification.schedule.hour === null) {
                    return null
                }

                return this.schedule !== null ? "1" : null
            },
        },
        hours() {
            return [...Array(24).keys()].map(h => {
                return { value: h, text: `${("0" + h).slice(-2)}:00` }
            })
        },
    },
    methods: {
        ...mapActions({
            logoutUser: "user/logout",
            setInfo: "user/setInfo",
        }),
        ...mapMutations({
            setDarkMode: "user/darkMode",
        }),

        logout() {
            this.me = null
            this.logoutUser()
            this.$router.push({ name: "login" })
        },
        removeEmails(key) {
            Vue.delete(this.me.notification.mail.emails, key)
        },
        addNotificationEmail() {
            this.me.notification.mail.emails.push("")
        },
        async update() {
            if (!this.$refs.form.validate()) {
                return
            }
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { updateUser },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/account/updateUser.gql"),
                    variables: {
                        notification: {
                            mail: this.me.notification.mail,
                            schedule: this.me.notification.schedule,
                        },
                        name: this.me.name,
                        password: this.me.password,
                        locale: this.me.locale,
                        address: this.me.address,
                    },
                })

                if (!updateUser.result) {
                    this.errors = updateUser.errors
                } else {
                    this.setInfo(this.me)

                    this.$notify({
                        title: this.$i18n.t("notify.updated"),
                        type: "success",
                    })

                    this.$router.push({ name: "dashboard" })
                }
            } catch (error) {
                console.log(error)
                this.errors = error.graphQLErrors.map(e => e.message)
            }
            this.loading = false
        },
        async changeEmail() {
            if (!this.$refs.emailForm.validate()) {
                return
            }
            this.loading = true
            this.errorsMail = []
            try {
                const {
                    data: { updateEmail },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/account/updateEmail.gql"),
                    variables: {
                        email: this.email,
                    },
                })

                if (!updateEmail.result) {
                    this.errorsMail = updateEmail.errors.map(e => {
                        return {
                            wait_period: updateEmail.wait_period,
                            key: e,
                        }
                    })
                } else {
                    this.emailSuccess = true
                }
            } catch (error) {
                this.errorsMail = error.graphQLErrors.map(e => e.message)
            }
            this.loading = false
        },
    },
    watch: {
        changeMailDialog() {
            this.emailSuccess = false
            this.errorsMail = []
            this.email = ""
        },
    },

    data() {
        return {
            loaded: false,
            emailSuccess: false,

            changeMailDialog: false,

            locales: [
                { value: "de", text: "Deutsch" },
                { value: "en", text: "English" },
                { value: "fr", text: "Français" },
                { value: "nl", text: "Nederlands" },
            ],
            showPassword: false,
            errorsMail: [],
            errors: [],
            rules: {
                min: v => {
                    if (!v) {
                        return true
                    }
                    return v.length >= 8 || this.$t("error.min", { n: 8 })
                },
                email: v => {
                    return (v && isEmail(v)) || this.$t("error.bad_format")
                },
                required: value => !!value || this.$t("error.required"),
            },

            password: "",
            email: "",
            me: {
                notification: {
                    schedule: { hour: null },
                    push: {
                        devices: [],
                    },
                    mail: {
                        emails: [],
                    },
                },
                email: "",
                name: "",
                locale: "",
                address: null,
            },
        }
    },
}
</script>
